// extracted by mini-css-extract-plugin
export default {"proposalAid":"ProposalAid_proposalAid__kL87b","likeAnimation":"ProposalAid_likeAnimation__qC90N"};